import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=0b3476a1&scoped=true&"
import script from "./Performance.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Performance.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=0b3476a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3476a1",
  null
  
)

export default component.exports